import packageJson from '../../../package.json';
import { EventName, UserInteractionEvent } from '../../models/GTMEventTypes';

let helixAnalytics = null;
let helixLoaded = false;

if (typeof window !== `undefined`) {
    import(`./HelixAnalytics`).then((module) => {
        helixAnalytics = module.helixAnalytics;
        helixLoaded = true;
    });
}

export const APP_CONFIG = {
    appName: `SpectrumReach`,
    appType: `Web`,
    startSession: `SpectrumReach_startSession_generic`,
    requirementsVersion: `2.389`,
    appVersion: packageJson.version,
    drmEnabled: true,
};

export const makeAnalyticsCall = (
    event: string,
    data?: {
        name?: string;
        category?: string;
        pageType?: string;
        action?: string;
        label?: string;
        value?: string;
    }
) => {
    const dataObj = {
        event,
        event_category: data.category,
        event_action: data.action,
        event_name: data.name,
        page_type: data.pageType,
        event_label: data.label,
        event_value: data.value,
    };
    if (typeof window !== `undefined`) {
        let environment = `dev`;
        const pageName = window.location.href
            .substring(window.location.href.lastIndexOf(`/`) + 1)
            .split(`?`)[0];
        const appSection = window.location.pathname.split(`/`)[1];
        const pagePaths: PagePaths = {
            domain: window.location.host,
            pageName: pageName === `` ? `Home` : pageName,
            appSection: appSection === `` ? `Home` : appSection,
        };
        if (
            pagePaths.domain.includes(`spectrumreach.com`) ||
            pagePaths.domain === `spectrumreach.spectrumtoolbox.com`
        ) {
            environment = `prod`;
        } else if (pagePaths.domain.includes(`stage`)) {
            environment = `stage`;
        } else {
            environment = `dev`;
        }

        if (!window[`dataLayer`] || !window[`drift`]) {
            setTimeout(() => makeAnalyticsCall(event, data), 100);
            return;
        }

        window[`dataLayer`].push({ ...dataObj, environment });

        if (event === EventName.PAGE_VIEW) {
            trackQuantumPageView(environment, pagePaths);
        }
    }
};

const trackQuantumPageView = (environment: string, pagePaths: PagePaths) => {
    if (helixLoaded) {
        helixAnalytics?.trackPageView(pagePaths.pageName, {
            appEnv:
                environment === `stage`
                    ? `staging`
                    : environment === `dev`
                    ? `local`
                    : environment,
        });
        helixAnalytics?.track(`generic_pageViewInit_video`, {
            msgEventType: `pageViewInit`,
            currPageAppSection: pagePaths.appSection,
            currPageName: pagePaths.pageName,
            currPageIsLazyLoad: true,
        });
        helixAnalytics?.track(`generic_pageView_video`, {
            msgEventType: `pageViewCompleted`,
            currPageAppSection: pagePaths.appSection,
            currPageName: pagePaths.pageName,
            currPageIsLazyLoad: true,
        });
    }
};

/**
 *
 * @param e The event to be passed through from the original onClick handler
 * @param eventAnalytics event analytics object of type UserInteractionEvent
 * @param onClick The original onClick handler to be called, if it existed
 * @description This function implements event tracking by calling the original onClick handler (if it exists) and then pushing analytical information of the event to the dataLayer
 */
export const onClickEventTracker = (
    e: React.MouseEvent<any, MouseEvent>,
    eventAnalytics: UserInteractionEvent,
    onClick?: (
        e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
    ) => void
) => {
    if (onClick && typeof onClick === `function`) {
        onClick(e);
    }

    if (typeof window !== `undefined` && window[`dataLayer`]) {
        window[`dataLayer`].push(eventAnalytics);
    }
};

interface PagePaths {
    domain: string;
    pageName: string;
    appSection: string;
}
